import { render } from "./overtime-tab.vue?vue&type=template&id=1ef38f10"
import script from "./overtime-tab.vue?vue&type=script&lang=js"
export * from "./overtime-tab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__